export default "__VITE_ASSET__POKNhYwI__"